import React from 'react';
interface SectionHeadingProps {
  index: string;
  title: string;
  note?: string;
  locked?: boolean;
  children?: React.ReactNode;
}
export function SectionHeading({
  index,
  title,
  note,
  locked = false,
  children
}: SectionHeadingProps) {
  return <div className="border-t-2 border-ink/12 pt-5" data-id="element-200" data-mp="3f2wwpkj9gxw6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-baseline sm:justify-between" data-id="element-201" data-mp="3jzdlmgyabgab">
        <div className="flex items-baseline gap-4" data-id="element-202" data-mp="bjty7ykaos36">
          <span className={`tnum font-sans text-[11px] font-semibold tracking-[0.18em] ${locked ? 'text-locked' : 'text-gold'}`} data-id="element-203" data-mp="bmgf4ot2sjy2">
            {index}
          </span>
          <h2 className={`font-display font-semibold text-[26px] leading-tight sm:text-[32px] ${locked ? 'text-locked' : 'text-ink'}`} data-id="element-204" data-mp="1spq9it1e7hu">
            {title}
          </h2>
        </div>
        {children}
      </div>
      {note ? <p className={`mt-2 max-w-measure font-sans text-[15px] leading-relaxed sm:ml-[46px] ${locked ? 'text-locked' : 'text-muted'}`} data-id="element-205" data-mp="zc0y37p8bh7c">
          {note}
        </p> : null}
    </div>;
}